import type { Dictionary } from '../../i18n/dictionary';

const pl = {
  appName: 'AG5',
  scripts: 'Skrypty',
  aiDude: 'AI Dude',
  debugWizard: 'Kreator debugowania',
  links: 'Linki',
  usefulLinks: 'Przydatne linki',

  scriptsTitle: 'Skrypty — AG5 — ITLamb',
  scriptTitle: (title: string) => `${title} — AG5 — ITLamb`,
  generate: 'Generuj',
  generatedScript: 'Wygenerowany skrypt',
  copy: 'Kopiuj',
  copied: 'Skopiowano',

  linksTitle: 'Przydatne linki — AG5 — ITLamb',
  addLink: 'Dodaj link',
  label: 'Etykieta',
  url: 'URL',
  icon: 'Ikona',
  add: 'Dodaj',
  save: 'Zapisz',
  cancel: 'Anuluj',
  editLink: (label: string) => `Edytuj link ${label}`,
  deleteLink: (label: string) => `Usuń link ${label}`,
  confirmDeleteLink: (label: string) => `Usunąć link „${label}”?`,
  noLinks: 'Brak linków. Dodaj pierwszy powyżej.',

  aiDudeTitle: 'AI Dude — AG5 — ITLamb',
  environment: 'Środowisko',
  localPort: 'Port lokalny',
  setPort: 'Ustaw port',
  apiLabel: 'API:',
  availableVersion: 'Dostępne — wersja',
  unavailable: 'API AI Dude jest niedostępne.',
  checking: 'Sprawdzanie…',
  checkAgain: 'Sprawdź ponownie',

  loadLinksFailed: 'Nie udało się wczytać linków.',
  addLinkFailed: 'Nie udało się dodać linku.',
  saveLinkFailed: 'Nie udało się zapisać linku.',
  linkSaved: 'Link zapisany.',
  deleteLinkFailed: 'Nie udało się usunąć linku.',
  loadEnvironmentsFailed: 'Nie udało się wczytać środowisk AI Dude.',
  checkAiDudeFailed: 'Nie udało się sprawdzić AI Dude.',
};

const en: typeof pl = {
  appName: 'AG5',
  scripts: 'Scripts',
  aiDude: 'AI Dude',
  debugWizard: 'Debug wizard',
  links: 'Links',
  usefulLinks: 'Useful links',

  scriptsTitle: 'Scripts — AG5 — ITLamb',
  scriptTitle: (title) => `${title} — AG5 — ITLamb`,
  generate: 'Generate',
  generatedScript: 'Generated script',
  copy: 'Copy',
  copied: 'Copied',

  linksTitle: 'Useful links — AG5 — ITLamb',
  addLink: 'Add link',
  label: 'Label',
  url: 'URL',
  icon: 'Icon',
  add: 'Add',
  save: 'Save',
  cancel: 'Cancel',
  editLink: (label) => `Edit link ${label}`,
  deleteLink: (label) => `Delete link ${label}`,
  confirmDeleteLink: (label) => `Delete link "${label}"?`,
  noLinks: 'No links yet. Add one above.',

  aiDudeTitle: 'AI Dude — AG5 — ITLamb',
  environment: 'Environment',
  localPort: 'Local port',
  setPort: 'Set port',
  apiLabel: 'API:',
  availableVersion: 'Available — version',
  unavailable: 'AI Dude API is unavailable.',
  checking: 'Checking…',
  checkAgain: 'Check again',

  loadLinksFailed: 'Could not load links.',
  addLinkFailed: 'Could not add the link.',
  saveLinkFailed: 'Could not save the link.',
  linkSaved: 'Link saved.',
  deleteLinkFailed: 'Could not delete the link.',
  loadEnvironmentsFailed: 'Could not load AI Dude environments.',
  checkAiDudeFailed: 'Could not check AI Dude.',
};

export const ag5Dict: Dictionary<typeof pl> = { pl, en };
